module.exports = __webpack_public_path__ + "bedroom-box.f349b226.png";